exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PrintButton__printButton___kiIBB {\n  color: #404040;\n  cursor: pointer;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  transition: 300ms; }\n  .PrintButton__printButton___kiIBB .PrintButton__icon___3oCdB {\n    margin-right: 8px;\n    font-size: 17px;\n    vertical-align: middle;\n    transition: 300ms; }\n  .PrintButton__printButton___kiIBB:hover {\n    color: #f94144; }\n    .PrintButton__printButton___kiIBB:hover .PrintButton__icon___3oCdB {\n      color: #f94144; }\n", ""]);

// exports
exports.locals = {
	"printButton": "PrintButton__printButton___kiIBB",
	"icon": "PrintButton__icon___3oCdB"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/PrintButton/styles/PrintButton.scss
// module id = 4597
// module chunks = 6